<template>
  <div class="blog-item-header bg-white-1">
    <b-row>
      <b-col
        cols="6"
      >
        <img
          class="blog-item-img float-left"
          :src="blogImg"
          alt="Fluid image"
        >
      </b-col>
      <b-col
        cols="6"
      >
        <div class="d-flex justify-content-end m-b-64">
          <ShareNetwork
            class="m-r-22 text-decoration-none"
            network="facebook"
            :url="shareUrl"
            :title="blogTitle"
          >
            <i class="i-fb" />
          </ShareNetwork>
          <ShareNetwork
            class="m-r-22 text-decoration-none"
            network="twitter"
            :url="shareUrl"
            :title="blogTitle"
          >
            <i class="i-tw" />
          </ShareNetwork>
          <ShareNetwork
            style="text-decoration: none"
            network="linkedIn"
            :url="shareUrl"
            :title="blogTitle"
          >
            <i class="i-in" />
          </ShareNetwork>
        </div>
        <div>
          <h4 class="text-primary font-weight-bold card-ctx f-s-30 m-b-36 l-h-20 m-b-24">
            {{ blogTitle }}
          </h4>
          <p class="text-primary l-h-20 grey-dark">
            {{ blogSubTitle }}
          </p>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import HOST from '@/store/host';

export default {
  name: 'BlogItemHeader',
  props: {
    blog: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    blogTitle() {
      return this.blog?.title || '';
    },
    blogSubTitle() {
      return `By ${this.blog?.createdBy} On ${this.blog?.date}`;
    },
    blogImg() {
      return this.blog?.image_url;
    },
    shareUrl() {
      return `${HOST}/blog/${this.blog?.id}/`;
    },
  },
};
</script>
